import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import type {RouteObject} from '@github-ui/react-router'
import type {ComponentType} from 'react'
import {buildReleasesIndexRoute, buildTagsIndexRoute} from './index-routes'

export interface ReleasesRouteComponents {
  ReleasesTagsLayoutRoute: ComponentType
  ReleasesIndex: ComponentType
  TagsIndex: ComponentType
}

export function createReleasesRoutes(
  appBuilder: DataRouterApplicationBuilder<string>,
  components: ReleasesRouteComponents,
): RouteObject[] {
  if (!isFeatureEnabled('repo_releases_and_tags_sidebar_layout')) return []

  return [
    appBuilder.createQueryRouteConfig('releasesTagsLayoutRoute', {path: '', queries: []}).toRoute({
      Component: components.ReleasesTagsLayoutRoute,
      children: [
        buildReleasesIndexRoute(appBuilder).toRoute({
          Component: components.ReleasesIndex,
          handle: {repoSubAppName: 'releases', selectedLink: 'repo_releases'},
        }),
        buildTagsIndexRoute(appBuilder).toRoute({
          Component: components.TagsIndex,
          handle: {repoSubAppName: 'releases', selectedLink: 'repo_tags'},
        }),
      ],
    }),
  ]
}
